import { fallbackValue } from "constants/fallbackConstant";

const formatHours = (timeRange) => {
  if (!timeRange?.start || !timeRange?.end) return fallbackValue;

  const options = { hour: "2-digit", minute: "2-digit", hour12: false };
  const start = new Date(timeRange.start).toLocaleTimeString([], options);
  const end = new Date(timeRange.end).toLocaleTimeString([], options);

  return `${start} - ${end}`; //Returns "HH:mm - HH:mm"
};

export default formatHours;
